// src/api/subscriptions.js
import axiosInstance from './axiosInstance';

// Start a Stripe Checkout session for Beem Plus
export const createCheckoutSession = (data = {}) =>
  axiosInstance.post('/api/subscriptions/create-checkout-session', data);

// Confirm a completed Checkout session
export const confirmSubscription = (sessionId) =>
  axiosInstance.post('/api/subscriptions/confirm', { sessionId });
